import { Expose } from 'class-transformer';
import dobToAge from 'dob-to-age';

import { SnModel } from '@lib/common/models';

export class FsWhoosterAddressModel extends SnModel {
  @Expose()
  public uuid: string;

  @Expose()
  public name: any[];

  @Expose()
  public relatives: any[];

  @Expose()
  public dob: any;

  @Expose()
  public phone: string[];

  @Expose()
  public email: string[];

  @Expose()
  public startDate: string;

  @Expose()
  public endDate: string;

  constructor(data: any) {
    super();
    this.fromJSON(data);
    this.uuid = data?.uuid ? data?.uuid : data?.personToken;
    this.name = this.isArrays(data?.names?.name) ? data?.names?.name : [data?.names?.name];
    this.relatives = this.isArrays(data?.relatives?.relative)
      ? data?.relatives?.relative.map((item) => item?.name)
      : data?.relatives?.relative?.name;
    this.dob = this.isArrays(data?.DOBs?.DOB)
      ? this.calcBday(data?.DOBs?.DOB[0])
      : this.calcBday(data?.DOBs?.DOB);
    this.email = this.isArrays(data?.emails?.email) ? data?.emails?.email : [data?.emails?.email];
    this.phone = this.isArrays(data?.otherPhones?.phone)
      ? data?.otherPhones?.phone
      : [data?.otherPhones?.phone];
    this.startDate =
      data?.firstDate?.month && data?.firstDate?.year
        ? `${data.firstDate.month}/${data.firstDate.year}`
        : null;
    this.endDate =
      data?.lastDate?.month && data?.lastDate?.year
        ? `${data.lastDate.month}/${data.lastDate.year}`
        : null;
  }

  public isArrays(item: any): boolean {
    return Array.isArray(item);
  }

  public calcBday(bday: any): any {
    let age;
    if (bday?.month && bday?.day && bday?.year) {
      age = dobToAge(`${bday.month}/${bday.day}/${bday.year}`);
    } else if (bday?.month && !bday?.day && bday?.year) {
      age = dobToAge(`${bday.month}/1/${bday.year}`);
    } else if (!bday?.month && !bday?.day && bday?.year) {
      age = dobToAge(`1/1/${bday.year}`);
    } else {
      age = '';
    }
    return age;
  }
}
